export default __webpack_public_path__ + "static/media/sheba-serv.697ff6fc.JPG";